import React, { useContext, useEffect, useState } from "react"
import ShareSocialReportModal from "./view/tracker/Modals/ShareSocialReportModal"
import { contactsService } from "./services/contactsService";
import { UserTypeContext } from "./context/userStatus";
import { ContactsContext } from "./context/userIContacts";
import { setAllContacts, setGroupContacts, setShareModalOpen } from "./store/actions/contactsActions";
import { ReportsTypeContext } from "./context/userIReports";
import { setSelectedRow, setSelectedRowDetails } from "./store/actions/reportTypeAction";
import { userService } from "./services/auth";
import PaymentPlanInfo from "./view/trackerNewV2/paymentplaninfo";
import { setUserObject } from "./store/actions/userTypeAction";

const CheckAndBlockPayments = () => {
    const { state: IUserTypeState, dispatch: userTypeDispatch } =
        useContext(UserTypeContext);
    let userValues = JSON.parse(localStorage.getItem("userValues"));
    const [userDetailsLoaded, setUserDetailsLoaded] = useState(false);
    const [visiblePaymentFree, setVisiblePaymentFree] = useState(false);
    const [subscriptionPlanEnded, setSubscriptionPlanEnded] = useState(false);
    const [subscriptionPlanEndedBilling, setSubscriptionPlanEndedBilling] = useState(false);
    useEffect(() => {
        getUserDetails()
    }, [])
    const getUserDetails = () => {
        const userId = {
            uid: IUserTypeState?.userId ? IUserTypeState?.userId : userValues?.uid,
        };
        userService
            .getUserById(userId)
            .then((data: any) => {
                setUserDetailsLoaded(true);
                userTypeDispatch(
                    setUserObject({
                        ...data?.data,
                        showGoal: data?.showGoal,
                        userSubscriptionStatus: data.userSubscriptionStatus
                    })
                );
                if (["FREE_PLAN_END"].includes(data.userSubscriptionStatus)) {
                    setSubscriptionPlanEnded(true)
                    setVisiblePaymentFree(true)
                    setSubscriptionPlanEndedBilling(false)

                }
                if (["SUBSCRIPTION_END"].includes(data.userSubscriptionStatus)) {
                    setSubscriptionPlanEndedBilling(true)
                    setSubscriptionPlanEnded(true)
                    setVisiblePaymentFree(true)
                }
                localStorage.setItem("userValues", JSON.stringify(data?.data));
            })
            .catch((error) => {
                console.log("User profile Error");
            });
    };

    return userDetailsLoaded && visiblePaymentFree &&
        <PaymentPlanInfo
            visiblePaymentInfo={visiblePaymentFree}
            onClose={() => {
                if (!subscriptionPlanEnded) {
                    localStorage.removeItem("showPayment")
                    setVisiblePaymentFree(false)
                }
            }}
            subscriptionPlanEndedBilling={subscriptionPlanEndedBilling}
            subscriptionPlanEnded={subscriptionPlanEnded}
        />
}

export default CheckAndBlockPayments